module.exports = __webpack_public_path__ + "img/app_qr_code.5c71bb2f.png";